export default {
  NONE: 'NONE',
  REQUEST: 'REQUEST',
  AUTO: 'AUTO',
};
